import { createContext, useState } from "react";
import type { IExamsContextData, IExamsProviderProps } from "./types";
import { createExamUtils } from "./utils";
import Loading from "../../components/Shared/Loading";

export const ExamsContext = createContext<IExamsContextData | null>(null);

export const ExamsProvider = ({ children }: IExamsProviderProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDetailExamsLoading, setIsDetailExamsLoading] = useState(false);

  const contextValue: IExamsContextData = {
    ...createExamUtils(setIsLoading, setIsDetailExamsLoading),
    isDetailExamsLoading,
  };

  return (
    <ExamsContext.Provider value={contextValue}>
      {isLoading && <Loading />}
      {children}
    </ExamsContext.Provider>
  );
};
